<form #form="ngForm" class="campanha-promocao-form" novalidate>
    <div class="row">
        <div class="form-group col-12">
            <label for="campanhaTipoPromocao" class="col-form-label">Tipo de Promoção</label>
            <sgt-tipo-promocao-campanha-select
                [ngModel]="tipoPromocao"
                (ngModelChange)="onChangeTipoPromocao($event)"
                name="campanhaTipoPromocao"
                id="campanhaTipoPromocao"
                #campanhaTipoPromocao="ngModel"
                [disabled]="!canEdit || !canEditTipoPromocao">
            </sgt-tipo-promocao-campanha-select>
            <p class="form-text" *ngIf="!tipoPromocao">
                Nenhuma promoção determinada para esta campanha
            </p>                        
            <p class="form-text" *ngIf="config?.isSemPromocao">
                Esta campanha não possui promoção
            </p>
            <p class="form-text" *ngIf="config?.isPromocaoCliente">
                Esta campanha promove clientes
            </p>
            <p class="form-text" *ngIf="config?.isPromocaoItem">
                Esta campanha promove itens
            </p>             
        </div>
    </div>

    <!-- Clientes -->
    <ng-template [ngIf]="isTipoCliente()">
        <sgt-campanha-cliente-form
            #clientesForm
            [entities]="clientes"
            [canEdit]="canEdit">
        </sgt-campanha-cliente-form>  
    </ng-template>

    <!-- Itens -->
    <ng-template [ngIf]="isTipoItem()">
        <sgt-campanha-item-form
            #itensForm
            [canEdit]="canEdit">
        </sgt-campanha-item-form>  
    </ng-template>    
</form>